module.exports = __webpack_public_path__ + "static/media/features_bg.45e7bdc2.jpg";